module.exports = __webpack_public_path__ + "static/media/l-point.977899b7.svg";